import { Checkbox, List, Popover, theme } from 'antd';
import { useTranslation } from 'react-i18next';
import { CheckCircleOutlined } from '@ant-design/icons';
import { observer } from 'mobx-react';

import { AlertEntity } from '@/comp/AlertsBar/Alert';
import { ComponentTierName } from '@/constants/enums';
import { checkTierPermission } from '@/utils/util-functions';
import { useStores } from '@/hooks/use-stores';
import { EPButton } from '@/components';
import BoxArrowDownIcon from '@/comp/common/icons/BoxArrowDownIcon';

import { AlertEmptyContainer, AlertsListContainer } from './AlertsList.styles';
import Alert from './Alert/Alert';
import useAlertsList from './AlertsList.utils';

const AlertsList = observer(({ alerts, archived }: { alerts: AlertEntity[]; archived?: boolean }) => {
  const { t } = useTranslation();
  const { stationStore } = useStores();
  const { token } = theme.useToken();
  const { isAllSelected, isPartSelected, onSelectAll, onClickArchiveSelected } = useAlertsList(alerts);
  const shouldRestrictAlerts = checkTierPermission(ComponentTierName.PaymentPlan, stationStore);

  if (!alerts.length) {
    return (
      <AlertEmptyContainer>
        <CheckCircleOutlined className="alert-empty-icon" />
        <span className="alert-empty-text">{t('noAlertsAtTheMoment')}</span>
        <span className="alert-empty-description">{t('viewPastAlerts')}</span>
      </AlertEmptyContainer>
    );
  }

  return (
    <AlertsListContainer>
      {!shouldRestrictAlerts && !archived && (
        <div className="all-selection">
          <Checkbox checked={isAllSelected} indeterminate={isPartSelected} onChange={onSelectAll}>
            {t('Select All')}
          </Checkbox>
          {(isAllSelected || isPartSelected) && (
            <Popover placement="bottom" content={<span>{t('Archive Selected Alerts')}</span>}>
              <EPButton
                type="link"
                size="medium"
                className="archive-all-icon"
                icon={<BoxArrowDownIcon color={token.colorPrimary} />}
                onClick={onClickArchiveSelected}
              />
            </Popover>
          )}
        </div>
      )}
      <List
        dataSource={alerts}
        renderItem={alert => (
          <List.Item>
            <Alert alert={alert} archived={archived} />
          </List.Item>
        )}
      />
    </AlertsListContainer>
  );
});

export default AlertsList;
